import {LOGIN_DETAILS,LOGOUT_DETAILS, MODULE,FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT,MODULE_AND_LOGINDIV_DISABLED} from './LoginType';

const initialState={
    UserName:'',
    Password:'',
    Role:'',
    CheckInRights:[],
    BoardingRights: [],
    Token:"",
    Theme:"",
    IsLogin:false,
    RoleCode: '',
    Module: 'Check-In',
    printersConfigBP: null,
    printersConfigBT: null,
    isFocusToSubheaderOfSeatmanagement: true,
    IsModulAndLoginDivDisabled:true
    // isFlyBigRequired: false
}

const loginReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        
        case LOGIN_DETAILS: return{
            ...state,
            UserName:action.UserName,
            Password:action.Password,
            Role:action.Role,
            CheckInRights:action.CheckInRights,
            BoardingRights: action.BoardingRights,
            Token:action.Token,
            Theme:action.Theme,
            IsLogin:action.IsLogin,
            Location:action.Location,
            RoleCode: action.RoleCode,
            printersConfigBT: action.bt,
            printersConfigBP: action.bp,
            // isFlyBigRequired: action.isFlyBigRequired
        }
        case LOGOUT_DETAILS: return{
            ...state,
            UserName:action.UserName,
            Password:action.Password,
            Role:action.Role,
            CheckInRights:action.CheckInRights,
            BoardingRights: action.BoardingRights,
            Token:action.Token,
            Theme:action.Theme,
            IsLogin:action.IsLogin,
            printersConfigBT: action.bt,
            printersConfigBP: action.bp,
            // isFlyBigRequired: action.isFlyBigRequired
        }
        case MODULE: return {
            ...state,
            Module: action.Module
        }
        case FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT: return{
            ...state,
            isFocusToSubheaderOfSeatmanagement: action.isFocusToSubheaderOfSeatmanagement
        }
        case MODULE_AND_LOGINDIV_DISABLED: return{
            ...state,
            IsModulAndLoginDivDisabled: action.IsModulAndLoginDivDisabled
        }
        default: return state
    }
}

export default loginReducer;